
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class GSTR1B2CSGrid extends Serenity.EntityGrid<POSSalesTaxRow, any> {
        protected getColumnsKey() { return 'Retail.GSTR1B2CS'; }
        protected getIdProperty() { return POSSalesTaxRow.idProperty; }
        protected getInsertPermission() { return POSSalesTaxRow.insertPermission; }
        protected getLocalTextPrefix() { return POSSalesTaxRow.localTextPrefix; }
        protected getService() { return GSTR1B2CSService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.setTitle("");
        }

        protected getButtons(): Serenity.ToolButton[] {
            super.getButtons();
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            //buttons.push(Common.PdfExportHelper.createToolButton({
            //    grid: this,
            //    onViewSubmit: () => this.onViewSubmit()
            //}));

            buttons.push(Common.ExcelExportHelper.createToolButton({
                grid: this,
                service: this.getService() + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            //buttons.push({
            //    title: 'Print Register',
            //    icon: 'fa fa-print text-blue',
            //    //icon: 'fa-cloud-download',
            //    onClick: () => {
            //        Common.ReportHelper.execute({
            //            reportKey: 'Finance.ContraRegister',
            //            params: {
            //                CompanyIds: this.view.params.CompanyIds,
            //                FinIds: this.view.params.FinancialYearIds,
            //            }
            //        });
            //    }
            //}
            //);
            return buttons;
        }
    }
}